export function FormSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className='flex w-full flex-col gap-4'>
      <div className='rounded-2xl border border-border bg-page p-6'>
        <div className='flex flex-col gap-3'>
          {Array.from({ length: rows }).map((_, i) => (
            <div
              key={i}
              className='h-16 animate-pulse rounded-lg bg-border/40'
            />
          ))}
        </div>
      </div>
    </div>
  )
}
